
Vue.component('videoPager', {
    props: ['postData'],
    template: '#video-page-template'
})

var vm = new Vue({
    el: '#vue-section',
    data: {
        posts: [],
        loading: false
    },
    beforeMount: function () {
        this.offset = parseInt(this.$el.attributes['data-init-offset'].value);
        this.total = parseInt(this.$el.attributes['data-total'].value);
        this.bannedIds = JSON.parse(this.$el.attributes['data-banned-ids'].value);
        this.take = 12;
    },
    updated: function () {
        epicaAddEventClick('#vue-section');
        lazyLoadInit();
        onResize();
    },
    mounted: function () {
        epicaAddEventClick('#vue-section');
        onResize();
    },
    methods: {
        getPosts: function () {
            if (!this.loading) {
                this.loading = true;
                var _self = this;
                this.$http.get('/api/pager/videos', {
                    params: {
                        limit: this.take,
                        offset: this.offset,
                        bIds: this.bannedIds
                    }
                })
                .then(function (response) {
                    _self.posts = _self.posts.concat(response.body);
                    _self.loading = false;
                    _self.offset += _self.take;
                }, function (response) {
                    _self.loading = false;
                });
            }
        }
    },
    computed: {
        pagerEnabled: function () {
            return this.offset < this.total && !this.loading;
        }
    }
});